import { Image } from '../types';

type ImageLike = Pick<Image, 'url' | 'galleryUrl' | 'thumbnailUrl'>;

export const getGalleryDisplayImageUrl = (image?: ImageLike | null): string => {
    if (!image) return '';
    return image.galleryUrl || image.url || image.thumbnailUrl;
};

export const buildGalleryResponsiveSrcSet = (image?: ImageLike | null): string | undefined => {
    if (!image) return undefined;

    const sources: string[] = [];
    const galleryImageUrl = getGalleryDisplayImageUrl(image);

    if (image.thumbnailUrl) {
        sources.push(`${image.thumbnailUrl} 400w`);
    }

    if (galleryImageUrl && galleryImageUrl !== image.thumbnailUrl) {
        sources.push(`${galleryImageUrl} 2400w`);
    }

    return sources.length > 1 ? sources.join(', ') : undefined;
};

export const preloadImage = (src?: string | null): void => {
    if (!src || typeof window === 'undefined') return;

    const preloadedImage = new window.Image();
    preloadedImage.decoding = 'async';
    preloadedImage.src = src;
};